import { render } from "./Recommend.vue?vue&type=template&id=412a24b0&scoped=true"
import script from "./Recommend.vue?vue&type=script&lang=js"
export * from "./Recommend.vue?vue&type=script&lang=js"

import "./Recommend.vue?vue&type=style&index=0&id=412a24b0&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412a24b0"]])

export default __exports__